<template>
  <div style="position: relative;">
    <el-form ref="techPersonnelFilter" :model="techPersonnelList" :size="defaultFormItemSize"
             label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="专家姓名" prop="formFilter.expertName">
          <el-input class="filter-item" v-model="techPersonnelList.formFilter.expertName"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="服务单位" prop="formFilter.serviceUnit">
          <el-input class="filter-item" v-model="techPersonnelList.formFilter.serviceUnit"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-form-item label="服务领域" prop="formFilter.serviceField">
          <el-input class="filter-item" v-model="techPersonnelList.formFilter.serviceField"
                    :clearable="true" placeholder=""
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetTechPersonnel">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshTechPersonnel(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('techPersonnel:all')"
                   @click="onTechPersonnelAddClick()">
          新增
        </el-button>
        <el-button slot="operator" type="success" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('techPersonnel:all')"
                   @click="onImportClick()">
          导入
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="techPersonnel" :data="techPersonnelList.TechPersonnel.impl.dataList" :size="defaultFormItemSize" @sort-change="techPersonnelList.TechPersonnel.impl.onSortChange"
                  header-cell-class-name="table-header-gray"
                  highlight-current-row @current-change="techPersonnelList.TechPersonnel.impl.currentRowChange"
        >
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="techPersonnelList.TechPersonnel.impl.getTableIndex" />
          <el-table-column label="专家姓名" prop="expertName" sortable="custom">
          </el-table-column>
          <el-table-column label="服务单位" prop="serviceUnit">
          </el-table-column>
          <el-table-column label="工作单位" prop="workUnit">
          </el-table-column>
          <el-table-column label="服务领域" prop="serviceField">
          </el-table-column>
          <el-table-column label="联系方式" prop="contactInfo">
          </el-table-column>
          <el-table-column label="乡镇、街道" prop="townStreet">
          </el-table-column>
          <el-table-column label="行政村（社区）" prop="administrativeVillage">
          </el-table-column>
          <el-table-column label="科技特派员类型" prop="personnelType">
          </el-table-column>
          <el-table-column label="职级" prop="jobGrade">
          </el-table-column>
          <el-table-column label="图片" prop="imageUrl">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.imageUrl, {id: scope.row.id, fieldName: 'imageUrl', asImage: true})"
                        :preview-src-list="getPictureList(scope.row.imageUrl, {id: scope.row.id, fieldName: 'imageUrl', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <span v-if="!scope.row.imageUrl">无图片</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remark" show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" sortable="custom" width="180px">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="150px">
            <template slot-scope="scope">
              <el-button @click.stop="onTechPersonnelEditClick(scope.row)" type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('techPersonnel:all')">
                编辑
              </el-button>
              <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                         :disabled="!checkPermCodeExist('techPersonnel:all')">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="techPersonnelList.TechPersonnel.impl.totalCount"
            :current-page="techPersonnelList.TechPersonnel.impl.currentPage"
            :page-size="techPersonnelList.TechPersonnel.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="techPersonnelList.TechPersonnel.impl.onCurrentPageChange"
            @size-change="techPersonnelList.TechPersonnel.impl.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>

    <el-dialog title="导入特派员信息" :visible.sync="techPersonnelList.importDialogVisible" width="500px" :close-on-click-modal="false"
               :close-on-press-escape="false"
    >
      <el-upload
        ref="upload"
        :auto-upload="false"
        :on-change="onFileChange"
        :file-list="techPersonnelList.fileList"
        accept=".xlsx,.xls"
        drag
        :limit="1"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">仅支持xlsx/xls格式文件，且不超过10MB</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button :size="defaultFormItemSize" @click="techPersonnelList.importDialogVisible = false">取消</el-button>
        <el-button type="primary" :size="defaultFormItemSize" :loading="techPersonnelList.isImporting" @click="onImportSubmitClick">确定导入</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters } from 'vuex';
import { findItemFromList } from '@/utils';
// eslint-disable-next-line no-unused-vars
import rules from '@/utils/validate.js';
import { TableWidget } from '@/utils/widget.js';
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
import { TechPersonnelController } from '@/api';

export default {
  name: 'techPersonnelList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      fit: 'scale-down',
      techPersonnelList: {
        formFilter: {
          expertName: undefined,
          serviceUnit: undefined,
          serviceField: undefined
        },
        formFilterCopy: {
          expertName: undefined,
          serviceUnit: undefined,
          serviceField: undefined
        },
        TechPersonnel: {
          impl: new TableWidget(this.loadTechPersonnelWidgetData, this.loadTechPersonnelVerify, true, true)
        },
        importDialogVisible: false,
        isImporting: false,
        fileList: [],
        isInit: false
      }
    }
  },
  methods: {
    onResetTechPersonnel () {
      this.$refs.techPersonnelFilter.resetFields();
      this.refreshTechPersonnel(true);
    },
    loadTechPersonnelWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        techPersonnelDtoFilter: {
          expertName: this.techPersonnelList.formFilterCopy.expertName,
          serviceUnit: this.techPersonnelList.formFilterCopy.serviceUnit,
          serviceField: this.techPersonnelList.formFilterCopy.serviceField
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        TechPersonnelController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          if (this.techPersonnelList.TechPersonnel.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.techPersonnelList.TechPersonnel.impl.currentRow.id, 'id');
              this.$refs.techPersonnel.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    loadTechPersonnelVerify (data) {
      return true;
    },
    refreshTechPersonnel (resetPage) {
      this.techPersonnelList.formFilterCopy = JSON.parse(JSON.stringify(this.techPersonnelList.formFilter));
      if (resetPage) {
        this.techPersonnelList.TechPersonnel.impl.refreshTable(true, 1);
      } else {
        this.techPersonnelList.TechPersonnel.impl.refreshTable();
      }
      if (!this.techPersonnelList.isInit) {
        // 初始化下拉数据
      }
      this.techPersonnelList.isInit = true;
    },
    onTechPersonnelAddClick () {
      let params = {
        mode: 'add',
        closeVisible: 1
      };
      this.$router.push({name: 'techPersonnelForm', query: params});
    },
    onTechPersonnelEditClick (row) {
      let params = {
        id: row.id
      };
      params.closeVisible = 1;
      this.$router.push({name: 'techPersonnelForm', query: params});
    },
    onDeleteClick (row) {
      this.$confirm('确定要删除该特派员信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        TechPersonnelController.delete(this, { id: row.id }).then(res => {
          this.$message.success('删除成功');
          this.refreshTechPersonnel(false);
        }).catch(e => {
          this.$message.error('删除失败');
        });
      }).catch(() => {});
    },
    onImportClick () {
      this.techPersonnelList.fileList = [];
      this.techPersonnelList.importDialogVisible = true;
    },
    onFileChange (file, fileList) {
      this.techPersonnelList.fileList = fileList.slice(-1);
    },
    onImportSubmitClick () {
      if (this.techPersonnelList.fileList.length === 0) {
        this.$message.warning('请选择要导入的文件');
        return;
      }
      this.techPersonnelList.isImporting = true;
      let formData = new FormData();
      formData.append('file', this.techPersonnelList.fileList[0].raw);
      TechPersonnelController.importData(this, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        if (res.success) {
          let data = res.data;
          this.$message.success(`导入完成：成功${data.successCount}条，失败${data.failCount}条`);
          if (data.failMessages && data.failMessages.length > 0) {
            this.$alert(data.failMessages.join('<br/>'), '导入失败详情', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定'
            });
          }
          this.techPersonnelList.importDialogVisible = false;
          this.refreshTechPersonnel(true);
        } else {
          this.$message.error(res.message);
        }
      }).catch(e => {
        this.$message.error('导入失败');
      }).finally(() => {
        this.techPersonnelList.isImporting = false;
      });
    },
    onResume () {
      this.refreshTechPersonnel();
    },
    formInit () {
      this.refreshTechPersonnel();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>

<style scoped>
</style>
